import { Injectable } from '@angular/core';
import { TenantSettings } from '../services/tenant-settings.service';

@Injectable()
export class CurrentTenantSettingsResolver  {

  constructor(private tenant: TenantSettings) { }

  resolve() {
    if (!this.tenant.isInit) {
      return this.tenant.init();
    }
  }
}
